module.exports = __webpack_public_path__ + "static/img/AARON_FINCH.2a02001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AARON_FINCH.jpg
// module id = WnsL
// module chunks = 0